import React from 'react'
import { getFirstNotEmpty } from '@corratech/pylot-utils'
import { useStoreConfig } from 'config'
import {
    getFileExtension,
    getTrimmedUrl,
    getFullCanonical
} from '@components/seo/src/util'
import Head from 'next/head'
import type { CategoryInterface, Maybe } from '@pylot-data/pylotschema'
import { ProductInterface } from '@pylot-data/pylotschema'
export type CategoryProps = {
    category: CategoryInterface
    pathname: string
    titleOverride?: string
    descriptionOverride?: string
    products?: Maybe<Array<ProductInterface>>
}

export const Category = ({
    category,
    pathname,
    titleOverride,
    descriptionOverride,
    products
}: CategoryProps): JSX.Element => {
    const config = useStoreConfig()
    const { seo, base } = config

    const titleFirst = getFirstNotEmpty([
        titleOverride,
        category?.meta_title,
        category?.name,
        seo.default.title
    ])
    const title = titleFirst
    const description = getFirstNotEmpty([
        descriptionOverride,
        category?.meta_description,
        seo.default.description
    ])

    let ogImageContent =
        products && getTrimmedUrl(products[0]?.small_image?.url!)
    let ogImageAlt = products && products[0]?.name

    if (category?.image) {
        if (category?.image != '') {
            ogImageContent = `${
                base.magentoBaseUrl
            }${category?.image?.substring(
                category?.image.indexOf('/media/') + 1
            )}`
            ogImageAlt = titleFirst
        }
    }
    return (
        <Head>
            <title>{title}</title>
            <meta name="title" content={title} />
            <meta name="keywords" content={String(category.meta_keywords)} />
            <meta name="description" content={String(description)} />
            <link
                rel="canonical"
                href={getFullCanonical(pathname, base.url.baseUrl)}
            />
            {/* TWITTER */}
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta
                property="twitter:domain"
                content={seo.default.twitter?.handle}
            />
            <meta
                property="twitter:url"
                content={getFullCanonical(pathname, base.url.baseUrl)}
            />
            <meta name="twitter:card" content={seo.default.twitter?.cardType} />
            <meta name="twitter:image" content={ogImageContent!} />
            {/* OPEN GRAPH */}
            <meta
                property="og:url"
                content={getFullCanonical(pathname, base.url.baseUrl)}
            />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={ogImageContent!} />
            <meta property="og:image:alt" content={ogImageAlt!} />
            <meta
                property="og:image:type"
                content={`image/${getFileExtension(ogImageContent!)}`}
            />

            <meta property="og:site_name" content={seo.default.twitter?.site} />
        </Head>
    )
}
